module.exports = __webpack_public_path__ + "static/media/achievement.ba4595cb.svg";